<template>
  <div>
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-card class="box">
      <v-toolbar flat dense class="toolbar">
        <v-toolbar-title>Bank Organization</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <v-btn class="button" @click="addBankDialog = true">Add New Bank</v-btn>
      </v-toolbar>
      <v-col cols="12" sm="3" md="3" v-if="bank_list.length != 0">
        <!-- <v-btn color="success" outlined rounded>
          <download-excel
            class="mr-2 pb-3 pt-2"
            :data="bank_list"
            :fields="table_fields"
            worksheet="PayRollBank"
            name="PayRollBank.xls"
          >
            <v-icon dark>mdi-file-excel</v-icon> Export
          </download-excel>
        </v-btn> -->
        <v-btn rounded color="success" outlined @click="fnExcelReport('my-table-id', 'Payrollbank')"
          :loading="loader"><v-icon color="success">mdi-export</v-icon>Export</v-btn>
      </v-col>
      <div id="my-table-id">
        <v-data-table :headers="headers" :items="bank_list" dense class="elevation-1 mytable" :search="search">
          <template v-slot:top>
            <v-toolbar flat dense color="white">
              <v-spacer></v-spacer>
              <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details>
              </v-text-field>
              <span style="width: 20px"></span>
              <v-dialog v-model="dialog" max-width="500px">
                <template v-slot:activator="{ on }">
                  <v-btn class="button" v-on="on">Add Bank</v-btn>
                </template>
                <v-card>
                  <v-card-title class="toolbar">
                    <span class="headline">{{ formTitle }}</span>
                  </v-card-title>

                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col cols="12" sm="12" md="12" v-if="editedIndex == -1">
                          <v-autocomplete dense outlined rounded item-value="id" item-text="bank"
                            :items="bank_super_master_list" v-model="addedItem.bank" multiple
                            label="Select Bank"></v-autocomplete>
                        </v-col>
                        <v-col cols="12" sm="12" md="12" v-if="editedIndex != -1">
                          <v-text-field dense outlined rounded v-model="editedItem.bank" persistent-hint
                            :disabled="editedIndex != -1" :hint="
                            editedIndex == -1
                              ? 'For example :: SBI, HDFC'
                              : 'Noneditable'
                          " label="Bank"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4" v-if="editedIndex != -1">
                          <v-checkbox dense v-model="editedItem.isactive" color="success" label="Active"></v-checkbox>
                        </v-col>
                        <v-row>
                          <v-col v-if="editedIndex == -1">
                            <v-checkbox dense v-model="addedItem.isactive" color="success"
                              label="Isactive"></v-checkbox>
                          </v-col>
                        </v-row>
                      </v-row>
                    </v-container>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="button" @click="close">Cancel</v-btn>
                    <v-btn class="button" v-if="!newbankcheckbox" @click="save">Save</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-toolbar>
          </template>

          <template v-slot:item.isactive="{ item }">
            <span v-if="item.isactive">
              <v-icon class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
            </span>
            <span v-else>
              <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
            </span>
          </template>

          <template v-slot:item.action="{ item }">
            <div>
              <v-avatar style="" size="25" class="edit-avatar">
                <v-icon class="edit-v-icon mr-2" @click="editItem(item)">edit</v-icon>
              </v-avatar>
            </div>
          </template>
        </v-data-table>
      </div>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-card>

    <v-dialog v-model="addBankDialog" max-width="900px" v-if="this.addBankDialog">
      <v-card class="card-container">
        <v-card-title class="toolbar">
          <span class="headline">Add New Bank</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row dense justify="center">
              <v-col cols="12" sm="8">
                <p><b>Bank Name</b></p>
                <v-text-field outlined dense type="text" v-model="new_bank_name" filled></v-text-field>
              </v-col>
              <v-col cols="12" sm="2">
                <p><b>Is-active</b></p>
                <v-checkbox v-model="new_bank_isactive" color="success" label="Is Active?"></v-checkbox>
              </v-col>
            </v-row>
            <!-- <br /> -->
            <v-row dense>
              <v-col cols="12" sm="12" md="1"></v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="mb-2 button" text @click="addBankDialog = false">Cancel</v-btn>
          <v-btn color="mb-2 button" @click="saveNewBank()" :disabled="!new_bank_name">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
  components: {
    Breadcrumbs,
  },
  data: () => ({
    overlay: false,
    // extraBreadcrumbItems: [
    //   { text: "Pay roll Bank", disabled: true, href: "" },

    // ],
    // breadcrumbClass: "breadcrumb-style1",
    errorMsg: {
      bank: false,
    },
    addBankDialog:false,new_bank_name:"",new_bank_isactive:true,
    snackbar_msg: "",
    color: "",
    snackbar: false,
    search: "",
    dialog: false,
    bank_super_master_list: null,
    newbankcheckbox: false,
    newbank: null,
    headers: [
      {
        text: "Bank",
        align: "left",
        sortable: false,
        value: "bank",
      },
      {
        text: "Active",
        align: "left",
        sortable: true,
        value: "isactive",
      },
      { text: "Actions", value: "action", sortable: false },
    ],
    table_fields: {
      Bank: "bank",
      Active: "isactive",
    },
    bank_list: [],
    editedIndex: -1,
    addedItem: {
      id: "",
      bank: "",
      isactive: true,
    },
    editedItem: {
      id: "",
      bank: "",
      bank_id: "",
      isactive: true,
    },
    defaultItem: {
      id: "",
      bank: "",
      bank_id: "",
      isactive: true,
    },
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "New Bank" : "Edit Bank";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    overlay(val) {
      val = () => {
        this.overlay = false;
      };
    },
  },

  // created () {
  //   this.initialize()
  // },
  mounted() {
    this.onLoad();
  },
  methods: {
    fnExcelReport(id, name) {
  let tab_text = `<table border='1px'>
    <tr>
      <th>Bank</th>
      <th>Is Active ?</th>
      
    </tr>`;

  this.bank_list.forEach((item, index) => {
    tab_text += `
    <tr>
        <td>${item.bank || ''}</td> 
        <td>${item.isActive ? 'InActive' : 'Active'}</td>
    </tr>`;
  });

  tab_text += '</table>';

  const blob = new Blob([tab_text], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  });
  const filename = name + '_' + parseInt(Math.random() * 10000000000) + '.xls';

  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    // For IE
    window.navigator.msSaveOrOpenBlob(blob, filename);
  } else {
    // For modern browsers
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.click();
    window.URL.revokeObjectURL(url);
  }
},
    saveNewBank(){
      const data = {
        bank_name: this.new_bank_name,
        is_active: this.new_bank_isactive
       }
      axios
        .post("/Payroll/saveNewPayrollBank", data)
        .then((res) => {
          if (res.data.flag == "Yes") {
            this.showSnackbar("#4caf50", "Bank Added Successfully...");
            this.addBankDialog=false,
            this.new_bank_name=""
            this.onLoad()
          } else {
             this.showSnackbar("#b71c1c",res.data.snackbar);
             this.addBankDialog=false,
             this.new_bank_name=""
          }
        })
        .catch((error) => {
          window.console.log(error);
        })
        .finally(() => {
          //overlay->loader
        });
    },
    initializeErrorMsgFalse() {
      this.errorMsg.bank = false;
    },
    onLoad() {
      this.overlay = true;
      axios
        .post("/Payroll/getPayRollBank")
        .then((res) => {
          if (res.data.msg == "200") {
            if ((this.load = true)) {
              this.overlay = false;
              this.bank_super_master_list = res.data.banklist;
              this.bank_list = res.data.bank_orglist;
            }
          } else {
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          window.console.log(error);
        })
        .finally(() => {
          var overlay = false;
        });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },

    editItem(item) {
      this.editedIndex = this.bank_list.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      if (this.editedIndex > -1) {
        if (this.isValidated()) {
          axios
            .post("/Payroll/editPayRollBank", this.editedItem)
            .then((res) => {
              if (res.data.fmsg == "YES") {
                Object.assign(
                  this.bank_list[this.editedIndex],
                  this.editedItem
                );
                this.showSnackbar(
                  "#4caf50",
                  "Bank Details Updated Successfully..."
                ); // show snackbar on success
              }
            })
            .catch((error) => {
              window.console.log(error);
            });

          this.close();
        }
      } else {
        axios
          .post("/Payroll/savePayRollBank", this.addedItem)
          .then((res) => {
            if (res.data.status.code == "YES") {
              //this.bank_list.push(this.addedItem);
              this.showSnackbar(
                "#4caf50",
                "Bank Details Added Successfully..."
              ); // show snackbar on success
              this.addedItem.bank=[]
              this.onLoad();
            } else if (res.data.status.code == "NA") {
              this.showSnackbar("#b71c1c", "Bank Details Already Present!!!"); // show snackbar on error
            }
          })
          .catch((error) => {
            window.console.log(error);
          });

        this.close();
      }
    }, // end of save()

    isValidated() {
      if (this.editedItem.bank) {
        return true;
      } else {
        if (!this.editedItem.bank) {
          this.errorMsg.bank = true;
        }

        return false;
      }
    }, // .....end of isValidated()
  },
};
</script>
<style scoped>
.v-text-field {
  padding-top: 0px;
  margin-top: 0px;
}
.v-icon-size {
  font-size: 20px;
}
.edit-avatar {
  transition: 0.3s;
  border: 1px solid #b0bec5;
}
.edit-avatar:hover {
  background-color: #b0bec5;
}
.edit-v-icon {
  padding-left: 6px;
  font-size: 15px;
}
.edit-v-icon:hover {
  color: white;
}
</style>
